<template>
  <v-text-field
    :label="required ? `${label}*`: label"
    v-model="valor"
    :hint="hintText"
    persistent-hint
    :error-messages="errorMessages"
    :required="required"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    :name="name"
    :disabled="disabled"
    :readonly="readonly"
    v-bind="extraOpt"
    :rules="[rules.email]"
  ></v-text-field>
</template>

<script>
import fieldMixin from "./mixins/fieldMixin";

export default {
  name: "EmailField",
  mixins: [fieldMixin],
  data: () => ({
    valor: null,
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'E-mail inválido.'
      },
    },
  }),
  mounted() {
    this.valor = this.value;
  },
  watch: {
    value(val) {
      this.valor = val;
    },
  },
}
</script>

<style scoped>

</style>
